import React, {useEffect, useState} from 'react'
import ErrorInfoComponent from "../../general/ErrorInfoComponent";

export default function VeranstalterLeagueOverview({eventOperatorId, userId, counter}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);


    useEffect(() => {
        ladeDaten();
    }, [eventOperatorId, counter]);


    const ladeDaten = () => {
        if (eventOperatorId === undefined) {
            return;
        }
    }

    return <div style={{padding: 10}}>
        <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)} onClearErrorMessage={() => setErrorMessage(undefined)}/>
        <div className="grid">
            <div className="col"><h3>Mannschaftsligen</h3></div>
        </div>
        <div style={{marginBottom: 10}}>Dein Veranstalter ist aktuell keiner durch Darthelfer geführten Mannschaftsliga zugewiesen!!!</div>
    </div>
}